import type { IRegistrationPageProps } from '$/pages/registration';
import type { NextRouter } from 'next/router';

import { useRouter } from 'next/router';
import { parse } from 'query-string';
import { useEffect } from 'react';

import useElb, { ElbProps } from '$/hooks/useElb';

export interface IRegistrationStateProps {
  elbProps: ElbProps;
}

const getQuery = (router: NextRouter) => {
  return parse(router.asPath.substr(router.asPath.indexOf('?') + 1));
};

const storeTrackingTokenInPersistStorage = (key: string, token: string) => {
  window.sessionStorage.setItem(key, token);
};

const isBase64 = (str: string) => {
  if (str === '' || str.trim() === '') {
    return false;
  }
  try {
    return btoa(atob(str)) == str;
  } catch (err) {
    return false;
  }
};

const useRegistration = (
  props: IRegistrationPageProps
): IRegistrationStateProps => {
  const router = useRouter();
  const { elbProps } = useElb();
  useEffect(() => {
    const routerQuery = getQuery(router);
    const dbTrToken = routerQuery.dbtr_token as string;

    if (dbTrToken) {
      storeTrackingTokenInPersistStorage('dbTrToken', dbTrToken);
    }

    const campaignToken = routerQuery.campaign_token as string;
    if (campaignToken && isBase64(campaignToken)) {
      storeTrackingTokenInPersistStorage('campaignToken', atob(campaignToken));
    } else {
      const currentCampaignToken =
        window.sessionStorage.getItem('campaignToken');
      if (!currentCampaignToken) {
        storeTrackingTokenInPersistStorage(
          'campaignToken',
          'not_defined__direct__direct__direct__direct'
        );
      }
    }
  }, []);

  return {
    elbProps,
  };
};

export default useRegistration;
